module.exports = __webpack_public_path__ + "img/google-play-login-mobile.5495ff12.png";